import { useMemo } from 'react';

import { IIdCodeTitle } from '@common/types';

import { useGetAmendmentExpatLovs } from '../amendment.slice';

export function useExpatLovs() {
  const { data: lovsData } = useGetAmendmentExpatLovs();

  const medicalClasses: IIdCodeTitle[] =
    lovsData?.planConfig?.getMedicalClasses ?? [];

  const expatLovs = useMemo<Record<string, string>>(
    () =>
      (medicalClasses ?? []).reduce(
        (acc, it) => {
          if (!it?.id) return acc;
          acc[it.id] = it.title || it.code || '';

          return acc;
        },
        {} as Record<string, string>
      ),
    [medicalClasses]
  );

  return expatLovs;
}
